<script setup lang="ts">
defineOptions({
  name: "ResultTab",
});

defineProps<{
  /** Label displayed on the tab button */
  label: string;
  /** Unique key for this tab */
  name: string;
}>();
</script>

<template>
  <div class="flex h-full min-h-0 flex-1 flex-col">
    <slot />
  </div>
</template>
